import { lazy } from '../../shared/deployment';
import { withIsActiveGuard } from '../utils';
import { MODULE_NAME } from './model/constant';

const PassThroughUserInitBase = lazy(() => import('./ui/pass-through-user-init'));

export const PassThroughUserInit = withIsActiveGuard(MODULE_NAME)(PassThroughUserInitBase);
